import i18n from 'i18next'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'

import variables from 'assets/styles/scss/shared/_variables.module.scss'

export const downloadTableAsPdf = (fileNameKey: string) => {
  const fileName = `${i18n.t(`reporting.fileName.${fileNameKey}`)}`
  const pdf = new jsPDF('p', 'mm', 'a3', true)
  autoTable(pdf, {
    html: '#jspdf-table',
    styles: {
      cellPadding: 3,
      fontSize: 10,
    },
    columnStyles: {
      2: {
        halign: 'right',
      },
    },
    headStyles: {
      fillColor: variables.white,
      textColor: variables.black,
    },
    didParseCell: function (table) {
      if (table.section === 'head' && table.column.index === 2) {
        table.cell.styles.halign = 'right'
      }
    },
  })

  pdf.save(fileName)
}
